import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { mainURL } from '../utils/common';
import { LicenceLeftMenu } from '../components/LicenceLeftMenu';
import { LeftSocialMediaIconUI } from '../components/LeftSocialMediaIconUI';

const List_of_unit_offices  = () => {
  const fileDownload=(fileStoreId)=>
  {
    
    let url=`${mainURL}/pwc-db-services/getPortalFiles`
     axios
        .post(url,{"fileId": fileStoreId, "userId": "392" })
        .then((res) => {
            console.log("response is --- ", res);

            if(res && res.data && res.status === 200) {
              const base64 = res.data[0] && res.data[0].base64_data;
              const pdfData = 'data:application/pdf;base64,'+base64;

              let html = '<html>' +
                  '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
                  '<body>' +
                  '<iframe src="' + pdfData + '"></iframe>' +
                  '</body></html>';
                  console.log(html);
              let a = window.open();
              a.document.write(html);
          }
        })
        .catch((e) => {
            // setLoader(false);
            console.log("The error is ", e);
        })
  }
const increaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
      var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
      var fontSize = parseFloat(style); 
      el[i].style.fontSize = (fontSize + 1) + 'px';
    }
  };
  const decreaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
    var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
    var fontSize = parseFloat(style); 
    el[i].style.fontSize = (fontSize - 1) + 'px'; 
    }
  };
  const { t, i18n, ready } = useTranslation();
  return (
    <>
  <section id="hero" className="hero hero2">
  <LeftSocialMediaIconUI />
    
    <div className="carousel-item active">
      <img src="assets/img/inner-bg2.png" className="img-fluid" alt="image" />
    </div>
  </section>
  <section className="section inner-pad1">
    <div className="container " >
      <div className="row">
      <div className="col-lg-3">
          <div className="site-menu  min-height-400">
            <LicenceLeftMenu />
          </div>
        </div>
        <div className="col-lg-9">
         <div className="container">
          <div className="row">
            <div className="inner-title2">
              <h3 className="fontSizeClass"> {t("Requirements For Obtaining CE")} </h3>
            </div>
            <div className="col-lg-12 about-head1">
              <div className="mayor-table2 depart min-height-400">
                <table className="table table-bordered">
                  <thead>
                    <tr className="table-warning table-bor-2">
                      <th className="bd-wid" scope="col">
                        {t("Sl-No")}
                      </th>
                      <th scope="col"> {("Ward Nos.")} </th>
                      <th scope="col"> {t("Address")} </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row"> 1 </th>
                      <td>001 to 009 </td>
                      <td>
                        {t("Cossipore Unit, 10, Barrackpore Trunk Road, 2nd Floor, Kol – 2")}
                      </td>
                      
                    </tr>
                    <tr>
                      <th scope="row">2 </th>
                      <td> 010 to 035, 038 &039</td>
                      <td> {t("Hatibagan Unit,79, Bidhan Sarani, Hatibagan Crossing, 2nd Floor, Kolkata – 6")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">3 </th>
                      <td> 036, 037 & 040 to 067 </td>
                      <td>  
                        {t("Head Quarter,C.M.O. Building, Ground Floor, 5, S.N. Benerjee Road, Kolkata – 13")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">4 </th>
                      <td> 068 to 100 </td>
                      <td>
                        {t("Gariahat Office, K.M.C. Market, 3rd Floor, 212, Rash Behari Avenue, Kolkata – 19")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">5 </th>
                      <td> 101, 102 & 110 to 114 </td>
                      <td>
                        {t("Jadavpore Office, Baghajatin Market Complex, 3rd Floor, Kolkata – 32")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">6 </th>
                      <td>103 to 109 </td>
                      <td>
                        {t("Santoshpur Office, Santoshpur K.M.C. Market Complex, 2nd Floor, Kolkata – 75")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">7 </th>
                      <td>115 to 122 127 to 132 </td>
                      <td>
                        {t("S. S. Unit Office,516, Diamond Harbour Road, 2nd Floor, Kolkata – 34")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row"> 8 </th>
                      <td> 133 to 141 </td>
                      <td>
                        {t("Garden Reach Office, E-3, Circular Garden Reach Road, Kolkata – 24.")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row"> 9 </th>
                      <td> 123 to 126 &amp; 142 to 144 </td>
                      <td> {t("Joka Office,4, Diamond Park, Kolkata – 700104.")} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

  )
}

export default List_of_unit_offices